export const GetWindTurbinesPerformanceFactorList = "GetWindTurbinesPerformanceFactorList";
export const GetWindTurbinesPerformanceFactorListSuccess = "GetWindTurbinesPerformanceFactorListSuccess";
export const GetWindTurbinesPerformanceFactorListError = "GetWindTurbinePesrformanceFactorListError";
